import 'react-toastify/dist/ReactToastify.css'

import { Provider } from 'react-redux'
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { store } from '../store'

import Loader from './Loader'
import Login from './Login'
import Market from './Market'
import Order from './Order'
import RefreshToken from './RefreshToken'
import MarketSlider from './SliderTest'

const App = (): JSX.Element => (
  <Provider store={store}>
    <Router>
      <RefreshToken>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/market" element={<Market />} />
          <Route path="/loader" element={<Loader />} />
          <Route path="/order/:orderId" element={<Order />} />
          <Route path="/markets" element={<MarketSlider />} />
          <Route path="*" element={<Navigate to="/market" replace />} />
        </Routes>
      </RefreshToken>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  </Provider>
)

export default App
